type BreadcrumbsDividerProps = {
  visible?: boolean;
};

const BreadcrumbsDivider = ({ visible = true }: BreadcrumbsDividerProps) => {
  return visible ? <span className="breadcrumbs__divider">/</span> : null;
};

export default BreadcrumbsDivider;
